module.exports = __webpack_public_path__ + "static/media/thermomix_tm6.8e4c0f42.png";